// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"EB","carousel__wrapper_on_sides":"FB","arrows_wrapper":"GB","arrows_wrapper_right":"HB","arrows_wrapper_vertical":"IB","arrows_wrapper_on_sides":"JB","arrow_button":"KB","carousel_arrow_left":"LB","carousel_arrow_left_on_side":"MB","carousel_arrow_right_on_side":"NB","carousel_arrow":"OB","arrows_wrapper_rounded":"PB","carousel__fullWidth":"QB"};
    if(module.hot) {
      // 1721922364122
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  